<template>
  <span>{{ displayedValue }}</span>
</template>

<script>
export default {
  name: 'AnimatedNumber',
  props: {
    value: { type: Number, default: 0 },
    duration: { type: Number, default: 800 }
  },
  data() {
    return {
      displayedValue: 0,
      rafId: null
    }
  },
  mounted() {
    this.$nextTick(() => this.animateTo(this.value))
  },
  beforeDestroy() {
    if (this.rafId) cancelAnimationFrame(this.rafId)
  },
  watch: {
    value(newVal) {
      this.animateTo(newVal)
    }
  },
  methods: {
    animateTo(target) {
      if (this.rafId) cancelAnimationFrame(this.rafId)
      const from = this.displayedValue
      const startTime = performance.now()
      const step = (now) => {
        const elapsed = now - startTime
        const t = Math.min(1, elapsed / this.duration)
        const eased = 1 - Math.pow(1 - t, 3)
        this.displayedValue = Math.round(from + (target - from) * eased)
        if (t < 1) {
          this.rafId = requestAnimationFrame(step)
        } else {
          this.rafId = null
        }
      }
      this.rafId = requestAnimationFrame(step)
    }
  }
}
</script>
